<template>
  <div class="time-table-input">
    <div class="select">
      <input type="text"
             class="form-control"
             :placeholder="$t('common.choose_date_time')"
             :value="selected_time_table_value"
             disabled="disabled"
             @click="show_modal = true">
    </div>

    <div class="modal-select d-flex" v-show="show_modal">
      <div class="d-flex flex-column">
        <datepicker
            ref="datePicker"
            input-class="form-control"
            format="dd.MM.yyyy"
            :full-month-name="true"
            :language="datepickerLanguage"
            :disabled-dates="disabledDates"
            initialView="day"
            :mondayFirst="true"
            maximum-view="day"
            :inline="true"
            v-model="time_table_date">
        </datepicker>
      </div>
      <div class="d-flex flex-column">
        <div v-if="time_table_date !== null" class="w-100 time-tables d-flex flex-wrap align-content-start" style="max-height: 386px;overflow-y: scroll;">
          <template>
            <div v-for="clinic in sorted_clinics" v-if="Object.keys(timeTables(clinic.id)).length > 0">
              <p>{{ clinic.title }}</p>
              <div class="time-tables-wrapper d-flex flex-wrap">
                <div class="time-table" v-for="time_table in timeTables(clinic.id)">
                  <button class="btn btn-blue btn-sm" :class="{'active': selected_time_table === time_table}"
                          v-if="!(time_table.is_visited || time_table.start_time < new Date())"
                          @click="chooseTimeTable(time_table)">
                    {{ formatTime(time_table.start_time) }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {ru, uk} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';
import config from '@/helpers/configDateFormats';
import {mapGetters} from "vuex";

export default {
  name: 'time-table-input',
  props: {
    time_table_groups: {
      required: true,
    },
    clinics: {
      required: false,
      default: () => [],
    },
    chooseClinic: {
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      sorted_clinics: [],

      show_modal: false,

      time_table_keys: Object.keys(this.time_table_groups),
      time_table_date: null,

      selected_time_table: null,
      selected_time_table_info: null,
      selected_time_table_value: null,
    };
  },
  methods: {
    setSelectedTimeTable(val) {
      this.selected_time_table = val;
    },
    formatTime(date) {
      return moment(date).format('HH:mm');
    },
    chooseTimeTable(timeTable) {
      this.selected_time_table = timeTable;
      this.selected_time_table_info = null;

      this.selected_time_table_value = moment(timeTable.start_time).format(config.DATE_TIME_FORMAT_SHORT);

      this.show_modal = false;

      this.$emit('input', timeTable);
    },
    timeTables(clinic_id = null) {
      if (this.time_table_date === null) {
        return [];
      }

      let dateKey = moment(this.time_table_date).format('YYYY-MM-DD');

      let timeTables = this.time_table_groups[dateKey];

      if (clinic_id == null) {
        return timeTables;
      }

      let filteredTimeTables = {};

      for (var index in timeTables) {
        var timeTable = timeTables[index][0];
        if (timeTable.clinic_id === clinic_id) {
          filteredTimeTables[index] = timeTable;
        }
      }

      let  sortedTimeTables = {};
      Object.keys(filteredTimeTables).sort().forEach(function(key) {
        sortedTimeTables[key] = filteredTimeTables[key];
      });
      return sortedTimeTables
    },
  },
  computed: {
    ...mapGetters([
      'language'
    ]),
    disabledDates() {
      return {
        customPredictor: (date) => {
          let dateKey = moment(date).format('YYYY-MM-DD');
          return Object.keys(this.time_table_groups).indexOf(dateKey) === -1;
        },
      };
    },
    datepickerLanguage(){
      let language = ru
      if(this.language){
        language = this.language === 'ua' ? uk : ru
      }
      return language
    }
  },
  watch: {
    time_table_groups(value) {
      this.time_table_keys = Object.keys(this.time_table_groups);
      if(this.disabledDates.customPredictor(this.time_table_date)){
        this.$refs.datePicker.clearDate()
      }

    },
    time_table_date(value) {
      if(value === null) return null
      let dateKey = moment(value).format('YYYY-MM-DD');
      let timeTables = Object.values(this.time_table_groups[dateKey])
      for (let time in timeTables){
        if(timeTables[time] instanceof Array){
          timeTables[time] = timeTables[time][0]

        }
      }
      this.sorted_clinics = this.clinics.sort((a, b) => {

        let aCount = timeTables
            .filter(time_table_group => {
              return time_table_group.clinic_id === a.id;
            })
            .length;

        let bCount = timeTables
            .filter(time_table_group => {
              return time_table_group.clinic_id === b.id;
            })
            .length;
        return bCount - aCount;
      });
    }
  },
  components: {
    Datepicker,
  },
}
</script>

<style lang="scss" scoped>
.date-input {
  position: relative;

  & > .fa {
    cursor: pointer;
    position: absolute;
    font-size: 20px;
    top: 14px;
    right: 14px;
  }
}
</style>
